import { ApiClient } from "../ApiClient";
class UsersApiClient {
    constructor() {
        this.apiClient = new ApiClient("/api/users");
    }
    logout() {
        return this.apiClient.post("/logout", {});
    }
    requestResetPassword(email) {
        return this.apiClient.post("/reset-password/request", { email });
    }
    resetPassword(data) {
        return this.apiClient.post("/reset-password", data);
    }
    getPostalDefinition(postalCode, countryCode) {
        return this.apiClient.get(`/check-postal?postalCode=${postalCode}&countryCode=${countryCode}`);
    }
    login(data) {
        return this.apiClient.post("/login", data);
    }
    register(data) {
        return this.apiClient.post("/register", data);
    }
    update(url, data) {
        return this.apiClient.put(url, data);
    }
    async getBidsCount(request) {
        return await this.apiClient.get(`/me/itemsForSale/bidsCount?${new URLSearchParams(request)}`);
    }
    async saveSearch(data) {
        return await this.apiClient.post("/searches", data);
    }
    async getSavedSearches() {
        return await this.apiClient.get("/searches");
    }
    async updateSearch(data) {
        return await this.apiClient.put("/searches", data);
    }
    async deleteSearch(searchQueryId) {
        return await this.apiClient.delete(`/searches/${searchQueryId}`, null);
    }
}
const usersApiClient = new UsersApiClient();
export default usersApiClient;
